import { ContentTypes } from '~/lib/contentful/constants/contentTypes';
import { ButtonData, LinkData } from '~/lib/contentful/custom-types';
import { buttonLinkRenderer } from '~/old-marketing/utils/buttonLinkRenderer';
import { linkRenderer } from '~/old-marketing/utils/linkRenderer';

export const actionsRenderer = (actions: (ButtonData | LinkData)[]) => {
  return actions.map((action) => {
    const isLink = action.__typename === ContentTypes.components.link;

    if (isLink) {
      return linkRenderer({
        analytics: {
          name: action.text,
        },
        id: action.id,
        children: action.text,
        href: action.url,
        tx: { mr: 8 },
        type: action.type,
      });
    }

    return buttonLinkRenderer({
      analytics: {
        name: action.text,
      },
      children: action.text,
      href: action.url,
      id: action.id,
      size: (action as ButtonData).size,
      tx: { mr: 8 },
      type: action.type,
      /** @ts-ignore temporary until we convert all marketing views to use the newest version of the parser */
      variant: action.variant,
    });
  });
};
